//development list view functions
let buildDevelopmentBlock = function(id) {
    let devDiv = document.createElement('div');
    devDiv.setAttribute('data-id', id);
    devDiv.className = 'wrapper';
    devDiv.id = id;
    devDiv.innerHTML = `
    <div class="item-wrapper">
      <div class="result-wrapper empty">
        <a href="#" class="image-wrapper">
          <img width="558" height="280" loading="lazy" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=">
        </a>
        <div class="content-wrapper">
        </div>
      </div>
    </div>`;
    let options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.2,
    };
    return {'element': devDiv, 'options': options};
};

let populateDevelopmentInfo = function(itemsInfo, dataId) {
    let itemStatus = ``;
    if (itemsInfo.status) itemStatus = `<span class="status">${itemsInfo.status}</span>`;

    let itemBrand = ``;
    if (itemsInfo.brand) itemBrand = `<a href="${itemsInfo.brand.url}"><img src="${itemsInfo.brand.brandImage.path}" alt="${itemsInfo.brand.brandImage.alt}"></a>`;

    let itemHomeIcon = ``;
    if (itemsInfo.homeIcon) itemHomeIcon = `
    <div class="details-content">
        <div class="icon"> <img src="${itemsInfo.homeIcon.path}" alt="${itemsInfo.homeIcon.alt}"> ${itemsInfo.propertyTypes}</div>
        <div class="icon"> <img src="${itemsInfo.currencyIcon.path}" alt="${itemsInfo.currencyIcon.alt}"> ${itemsInfo.priceRange}</div>
    </div>`;

    let itemCallTracking = ``;
    if (itemsInfo.callTracking) {
        let phoneNumberCollapsed = itemsInfo.callTracking.phoneNumber.replace(/\s/g, '');
        itemCallTracking = `
            <div class="call-tracking-number">
                <a href="tel:${phoneNumberCollapsed}">${itemsInfo.callTracking.phoneNumber}</a>
            </div>`;
    }

    let itemPropertiesButtonLabel = `<span></span>`;
    if (itemsInfo.viewPropertiesButtonLabel) itemPropertiesButtonLabel = `
    <button type="button" class="prop-table button button--secondary" aria-expanded="false" aria-controls="prop-table-${dataId}">${itemsInfo.viewPropertiesButtonLabel} <span class="icon-plus"></span></button>`;

    return `
    <div class="item-wrapper">
        <div class="result-wrapper loaded">
            <a href="${itemsInfo.viewDevelopmentButton.url}" class="image-wrapper" title="${itemsInfo.previewImage.alt}">
                <img width="558" height="280" loading="lazy" src="${itemsInfo.previewImage.path}" alt="${itemsInfo.previewImage.alt}">
            </a>
            <div class="content-wrapper">
                <div class="content-info">
                    <div class="info-wrapper">
                    <h2>${itemsInfo.name}</h2>
                    <span class="address">${itemsInfo.address}</span>
                        ${itemStatus}
                    </div>
                    <div class="logo-content">${itemBrand}</div>
                </div>
                <div class="bottom-wrapper">
                    <div class="bottom-info">
                        ${itemHomeIcon}
                        <div class="action-wrapper">
                            ${itemCallTracking}
                        </div>
                    </div>
                    <p class="description">${itemsInfo.shortDescription}</p>
                    <div class="cta-wrapper">
                        ${itemPropertiesButtonLabel}
                        <a href="${itemsInfo.viewDevelopmentButton.url}" class="button button--primary" title="${itemsInfo.viewDevelopmentButton.name}">
                    ${itemsInfo.viewDevelopmentButton.name}
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="table-results-wrapper" id="prop-table-${dataId}">
            <div class="property-list-component alt-background">
                <input type="hidden" class="num-per-page" value="2">
                <input type="hidden" class="data-source-page-id" value="">
                <div class="table-wrapper">
                </div>
            </div>
        </div>
    </div>
    `;
};

let populateDevelopmentProperties = function(plotInfo, tableWrapper, developmentElement) {
    const HEADINGS = plotInfo.headings;
    const ITEMS = plotInfo.items;
    const CONFIGURATION = plotInfo.configuration;
    const PROP_LIST_TAB = tableWrapper.querySelector('.property-list-component');
    const TABLE_WRAPPER = tableWrapper.querySelector('.property-list-component .table-wrapper');
    const TABLE = document.createElement('table');
    TABLE.setAttribute('class', 'pagination');
    TABLE_WRAPPER.appendChild(TABLE);
    PROP_LIST_TAB.appendChild(TABLE_WRAPPER);
    for (const field in plotInfo) {
        const THEAD = document.createElement('thead');
        const TABLE_ROW = document.createElement('tr');
        THEAD.appendChild(TABLE_ROW);
        const TBODY = document.createElement('tbody');
        if (field == 'headings') {
            for (const child in HEADINGS) {
                const HEADER_CELL = document.createElement('th');
                TABLE_ROW.appendChild(HEADER_CELL);
                HEADER_CELL.innerText = HEADINGS[child];
                TABLE.appendChild(THEAD);
            }
            const HEADER_CELL = document.createElement('th');
            HEADER_CELL.classList.add('disabled-sorting');
            TABLE_ROW.appendChild(HEADER_CELL);
            TABLE.appendChild(THEAD);
        } else if (field == 'items') {
            for (const child in ITEMS) {
                const TABLE_ROW = document.createElement('tr');
                let item = ITEMS[child].fields;
                let btn = ITEMS[child].button;
                for (const row in item) {
                    const TABLE_DATA = document.createElement('td');
                    TABLE_ROW.appendChild(TABLE_DATA);
                    TBODY.appendChild(TABLE_ROW);
                    TABLE.appendChild(TBODY);
                    if (row === 'propertynumber') {
                        if (btn.url !== '') {
                            let link = document.createElement('a');
                            link.setAttribute('href', btn.url);
                            link.innerHTML = item[row];
                            link.setAttribute('class', 'link--default');
                            link.setAttribute('title', btn.tooltip);
                            TABLE_DATA.appendChild(link);
                        } else {
                            TABLE_DATA.innerText = item[row];
                        }
                    }
                    else {
                        TABLE_DATA.innerText = item[row];
                    }
                }
                if (btn.url !== '') {
                    let link = document.createElement('a');
                    link.setAttribute('href', btn.url);
                    link.innerHTML = btn.name;
                    link.setAttribute('class', 'button button--primary');
                    link.setAttribute('title', btn.name);
                    let NEW_CELL = TABLE_ROW.insertCell(-1);
                    NEW_CELL.appendChild(link);
                } else {
                    let link = document.createElement('span');
                    link.innerHTML = btn.name;
                    let NEW_CELL = TABLE_ROW.insertCell(-1);
                    NEW_CELL.appendChild(link);
                }
            }
        }
    }
    if (ITEMS !== undefined && ITEMS.length !== 0) {
        let dataTable = tableUtils.initPaginatedDataTable(developmentElement, CONFIGURATION, true, true);
        
        let paginationWrapper = developmentElement.querySelector('.dataTable-pagination');
        if (paginationWrapper && paginationWrapper.hasChildNodes()) {
            tableUtils.initPaginationControlStates(dataTable, paginationWrapper);
            tableUtils.displayFirstPageAfterSort(dataTable, developmentElement);
        }
    }
};